import photoConcert from './images/acceuil/concert.jpg'

function Acceuil(){
  return (
    <div>
      <div className="App-photoCouv">
        <img src={photoConcert} className="photoConcert" alt="logo" />
        <p className='App-Slogan'>Mettez vos évènements en Lumière !</p>
      </div>
      <div className="App-presentation">
        <p>
          <b>BazEvent</b>, c’est le partenaire idéal pour donner vie à vos événements grâce au son et à la lumière.
          Spécialisée dans la prestation technique et artistique, notre société met à votre disposition tout son savoir-faire pour créer des ambiances uniques et immersives.
        </p>
        <p>Nous assurons :</p>
        <ul>
          <li><b>La sonorisation professionnelle</b> : installation et gestion de systèmes audio adaptés à tout type d’événement (spectacles, concerts, galas, pièces de théâtre, conférences, soirées privées, etc.).</li>
          <li><b>L’éclairage scénique et architectural</b> : mise en place de solutions lumineuses sur mesure pour sublimer vos représentations et vos espaces.</li>
          <li><b>La création lumière</b> : conception artistique et mise en scène lumineuse pour donner une véritable identité visuelle à vos événements.</li>
          <li><b>L’accompagnement global</b> : de l’étude technique à l’installation sur site, nous veillons à chaque détail pour que votre projet se déroule en toute sérénité.</li>
        </ul>
        <p>
          Avec BazEvent, chaque instant devient une expérience sensorielle et mémorable.
          Notre objectif : <b>mettre en valeur vos artistes, vos spectacles et vos idées grâce à des solutions son et lumière innovantes et personnalisées.</b>
        </p>
      </div>
    </div>
  )
}

export default Acceuil;